export const anchorScroll = () => {
  const urlHash = location.hash;

  if (urlHash) {
    window.scrollTo(0, 0);
    setTimeout(() => {
      const target = document.querySelector(urlHash);
      if (!target) return;
      const position = target.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top: position, behavior: "smooth" });
    }, 500);
  }

  document.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener("click", (e) => {
      const href = link.getAttribute("href");
      if (!href || href === "#") return;
      const target = document.querySelector(href);
      if (!target) return;

      e.preventDefault();
      const position = target.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top: position, behavior: "smooth" });
    });
  });
};

export default anchorScroll;
